var map = {
	"./android/Device": 945,
	"./androidtv/Device": 1106,
	"./arris/Device": 1111,
	"./hisense/Device": 1122,
	"./lg/Device": 1132,
	"./nagra/Device": 1141,
	"./netrange/Device": 1152,
	"./opera/Device": 1160,
	"./polaroid/Device": 1168,
	"./ps4/Device": 1176,
	"./samsung/Device": 1184,
	"./seirobotics/Device": 1192,
	"./sony/Device": 1197,
	"./stbcoship/Device": 1205,
	"./stbcoship9108/Device": 1209,
	"./stbhuawei/Device": 1213,
	"./stbkaon/Device": 1217,
	"./tizen/Device": 1220,
	"./web0s/Device": 1229,
	"./workstation/Device": 591,
	"./workstationChafari/Device": 1243,
	"./zeasn/Device": 1251,
	"./zte/Device": 1259
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 944;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/Device$
// module id = 944
// module chunks = 0